import { configureStore } from "@reduxjs/toolkit";
import alertReducer from "./alertSlice";
import selectedFolderSlice from "./selectedFolderSlice";
import folderReducer from "./folderSlice";
import resourceCreatedSlice from "./resourceCreatedSlice";
import resourceDeletedSlice from "./resourceDeletedSlice";
import resourceModifiedSlice from "./resourceModifiedSlice";
import resourceAddedSlice from "./resourceAddedSlice";
import rowSelectedSlice from "./rowSelectedSlice";
import dragRowSlice from "./dragRowSlice";
import recentViewedSlice from "./recentViewedSlice";
import settingSlice from "./settingsSlice";
import breadcrumbSlice from "./breadcrumbSlice";
import messageCountReducer from "./messageCountSlice";
import impersonationReducer from "./impersonationSlice";
import suggestedFolderSelectedSlice from "./suggestedFolderSelectedSlice";
import clearSearchTextSlice from "./clearSearchTextSlice";

export const store = configureStore({
  reducer: {
    alert: alertReducer,
    selectedFolder: selectedFolderSlice,
    folders: folderReducer,
    resourceCreated: resourceCreatedSlice,
    resourceDeleted: resourceDeletedSlice,
    resourceModified: resourceModifiedSlice,
    rowSelected: rowSelectedSlice,
    dragRowSelected: dragRowSlice,
    recentViewedUpdated: recentViewedSlice,
    settings: settingSlice,
    breadcrumbs: breadcrumbSlice,
    messageCount: messageCountReducer,
    impersonation: impersonationReducer,
    suggestedFolderSelected: suggestedFolderSelectedSlice,
    resourceAddedSlice: resourceAddedSlice,
    clearSearchTextSlice: clearSearchTextSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
